/* KOMTO — lite YouTube embed: iframe only on click. */
(function () {
  function mount(el) {
    var id = el.getAttribute('data-yt-id'); if (!id) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    f.title = 'YouTube video'; f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.setAttribute('allowfullscreen', ''); f.setAttribute('loading', 'lazy');
    el.innerHTML = ''; el.appendChild(f); el.classList.add('is-playing');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.komto-yt__btn'); if (!b) return;
    var el = b.closest('.komto-yt'); if (el) { e.preventDefault(); mount(el); }
  });
})();
